import { render, staticRenderFns } from "./AnalyticsPageviewsReport.vue?vue&type=template&id=5c2936fc&scoped=true&"
import script from "./AnalyticsPageviewsReport.vue?vue&type=script&lang=js&"
export * from "./AnalyticsPageviewsReport.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsPageviewsReport.vue?vue&type=style&index=0&id=5c2936fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2936fc",
  null
  
)

export default component.exports